import { DISCOUNT_TYPE } from 'app-shared/lib/api/shared';
import { defaultTheme } from 'ui-components';

/**
 * Return a phone number formatted for display.
 * @param phoneNumber the phone number to format.
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  let phoneNumberFormatted = phoneNumber;

  if (phoneNumber && phoneNumber.length == 10) {
    phoneNumberFormatted = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }

  return phoneNumberFormatted;
};

/**
 * Return a price formatted for display.
 * @param price the price to format.
 */
export const formatPrice = (price: number, textForZero = 'Gratuit', frenchFormat = true): string => {
  if (textForZero != null && !price) return textForZero;

  const formattedPrice = String(price.toFixed(2)) + ' €';

  return (frenchFormat && formattedPrice.replace('.', ',')) || formattedPrice;
};

/**
 * Return the color to display for bullet.
 * @param isStatusSuccess true if bullet status is success, false else.
 */
export const getBulletColor = (isStatusSuccess: boolean): string => {
  if (isStatusSuccess) {
    return defaultTheme.palette.success.main;
  }

  return defaultTheme.palette.error.main;
};

/**
 * Uppercase the first letter of a word
 * @param word the word.
 */
export const upperCaseFirstLetter = (word: string): string => {
  if (!word) return;

  return word.charAt(0).toUpperCase() + word.slice(1);
};

/**
 * Return a distance formatted for display.
 * @param distance the distance to format in meters.
 */
export const formatDistance = (distance: number): string => {
  let distanceLabel = '';

  if (distance == null) {
    distanceLabel = `à ... km`;
  } else if (distance < 100) {
    distanceLabel = `à ${Math.round(distance / 10) * 10} m`;
  } else if (distance < 1000) {
    distanceLabel = `à ${Math.round(distance / 100) * 100} m`;
  } else {
    distanceLabel = `à ${Math.round(distance / 100) / 10} km`;
  }

  return distanceLabel;
};

const DISCOUNT_VALUE_END_ADORNMENTS = {
  DEVISE: '€',
  PERCENTAGE: '%',
  PRODUCT: '',
};

/**
 * Gets discount type unit
 */
export const getDiscountTypeUnit = (discountType: DISCOUNT_TYPE): string => {
  return DISCOUNT_VALUE_END_ADORNMENTS[discountType];
};

export const formatUserName = (firstName?: string | null, lastName?: string | null, emptyLabel = '-') => {
  if (!firstName && !lastName) return emptyLabel;

  const userName = `${firstName} ${lastName}`;

  return userName;
};

export const formatAvatarInitials = (userName?: string | null): string => {
  if (!userName) return '';

  const regexp = /([a-zA-Z]{1})[a-zA-Z]+/g;
  const matches = [];
  let match;

  while ((match = regexp.exec(userName)) !== null) {
    matches.push(match);
  }

  const firstMatch = matches.length > 0 ? matches[0][1] : '';
  const lastMatch = matches.length > 1 ? matches[matches.length - 1][1] : '';

  const initials = firstMatch + lastMatch;
  const upperCaseInitials = initials.toUpperCase();

  return upperCaseInitials;
};
